import storePersist, { localConstant } from "../../../services/localStorage";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  getRequestAuthenticationRequest,
  postAuthenticationRequest,
  uploadImageCopartRequest,
  putAuthenticationRequest,
} from "../../../services/apiManager/apiRequests";
import {
  VEHICLE_ADD_FAILED_REQUEST,
  VEHICLE_ADDED_FAILED,
  VEHICLE_ADDED_SUCCESS,
  VEHICLE_LIST_FETCH_FAILED,
  VEHICLE_LIST_FETCH_FAILED_REQUEST,
  VEHICLE_LIST_FETCH_LOADING_REQUEST,
  VEHICLE_LIST_FETCH_SUCCESS,
  VEHICLE_DETAILS_LOADING_REQUEST,
  VEHICLE_DETAILS_FETCH_SUCCESS,
  VEHICLE_DETAILS_FETCH_FAILED,
  VEHICLE_DETAILS_FETCH_FAILED_REQUEST,
  VEHICLE_DETAILS_UPLOAD_IMAGE_REQUEST,
  VEHICLE_DETAILS_UPLOAD_IMAGE_SUCCESS,
  VEHICLE_DETAILS_UPLOAD_IMAGE_FAILURE,
  VEHICLE_DELETE_FAILED_REQUEST,
  EDIT_VEHICLE_DETAILS_REQUEST,
  EDIT_VEHICLE_DETAILS_SUCCESS,
  EDIT_VEHICLE_DETAILS_FAILURE,
  SET_SELECTED_VEHICLE_DETAILS,
} from "../constants";
import axios from "axios";
import { generateUUID, getDeviceName } from "../../../utils";

export const addVehicle =
  (params, uploadedImage, uploadedLicensePlate, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: VEHICLE_LIST_FETCH_LOADING_REQUEST,
        payload: { isLoading: true },
      });
      const formData = new FormData();
      formData.append(
        "preValidatedMetadata",
        JSON.stringify({
          visibility: "PRIVATE",
          lifespan: "PERMANENT",
        }),
      );
      formData.append("uploadType", "DOCUMENT");
      formData.append("entityType", "SAFE_TRUCK_PARKING");
      const mediaInfosArray = [];
      for (let index = 0; index < params?.fileInfosArray?.length; index++) {
        const file = params?.fileInfosArray[index];
        const obj = {
          name: file.name,
          mediaType: file.mediaType,
          mediaCode: file.mediaCode,
        };
        mediaInfosArray.push(obj);
        formData.append(file.name, file.mediaObj);
      }
      formData.append("fileInfos", JSON.stringify(mediaInfosArray));
      const json = {
        cust_id: params.cust_id,
        lic_plate_num: params.plateNumber,
        veh_type_cd: params.veh_type_cd,
        make: params.make,
        model: params.model,
        color: params.color,
        status: "A",
        source_sys: "mainGate",
        dotNumber: params.dotNumber,
        crt_user: params.ct_user,
        vehicleStatus: "ACTIVE",
        trailerNumber: params.trailerNumber,
      };
      const vehicleBlob = new Blob([JSON.stringify(json)], {
        type: "application/json",
      });
      formData.append("vehicle", vehicleBlob);
      const response = await postAuthenticationRequest(
        apiConfig.addVehicle,
        formData,
        null,
        "",
        "multipart/form-data",
      );
      if (response) {
        dispatch({
          type: VEHICLE_ADDED_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: VEHICLE_ADDED_FAILED,
          payload: response,
        });
        callback(response);
      }
    } catch (error) {
      callback(error);
      dispatch({
        type: VEHICLE_ADD_FAILED_REQUEST,
        payload: error,
      });
    }
  };

export const uploadImage =
  (uploadedFile, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: VEHICLE_DETAILS_UPLOAD_IMAGE_REQUEST,
        payload: { loading: true },
      });
      const formData = new FormData();
      formData.append(
        "preValidatedMetadata",
        JSON.stringify({
          visibility: "PRIVATE",
          lifespan: "PERMANENT",
        }),
      );
      formData.append(
        "fileInfos",
        JSON.stringify([
          {
            name: "file0",
          },
        ]),
      );
      formData.append("uploadType", "DOCUMENT");
      formData.append("entityType", "SAFE_TRUCK_PARKING");
      formData.append("file0", uploadedFile);
      const response = await uploadImageCopartRequest(
        apiConfig.vehicleDetailsUploadImage,
        formData,
      );
      if (response) {
        dispatch({
          type: VEHICLE_DETAILS_UPLOAD_IMAGE_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: VEHICLE_DETAILS_UPLOAD_IMAGE_FAILURE,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      callback({});
      dispatch({
        type: VEHICLE_DETAILS_UPLOAD_IMAGE_FAILURE,
        payload: {},
      });
    }
  };

export const getVehicles =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: VEHICLE_LIST_FETCH_LOADING_REQUEST,
        payload: { loading: true },
      });
      const vehicleListURL = apiConfig.addVehicle + "/" + params.cust_id;
      const response = await getRequestAuthenticationRequest(
        vehicleListURL,
        {},
      );
      if (response) {
        dispatch({
          type: VEHICLE_LIST_FETCH_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: VEHICLE_LIST_FETCH_FAILED,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      callback({});
      dispatch({
        type: VEHICLE_LIST_FETCH_FAILED_REQUEST,
        payload: {},
      });
    }
  };

export const getVehicleDetails =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: VEHICLE_DETAILS_LOADING_REQUEST,
        payload: { loading: true },
      });
      const vehicleDetailsURL = apiConfig.addVehicle + "/" + params.vehicleId;
      const response = await getRequestAuthenticationRequest(
        vehicleDetailsURL,
        params,
      );
      if (response) {
        dispatch({
          type: VEHICLE_DETAILS_FETCH_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: VEHICLE_DETAILS_FETCH_FAILED,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      callback({});
      dispatch({
        type: VEHICLE_DETAILS_FETCH_FAILED_REQUEST,
        payload: {},
      });
    }
  };

export const deleteVehcile =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const vehicleDeleteURL =
        apiConfig.addVehicle + "/delete/" + params?.veh_id;
      const response = await putAuthenticationRequest(vehicleDeleteURL, params);
      if (response) {
        callback(response);
      } else {
        callback({});
      }
    } catch (error) {
      callback({});
      dispatch({
        type: VEHICLE_DELETE_FAILED_REQUEST,
        payload: {},
      });
    }
  };

export const editVehicleDetails =
  (params, uploadedImage, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: EDIT_VEHICLE_DETAILS_REQUEST,
        payload: { loading: true },
      });
      const formData = new FormData();
      formData.append(
        "preValidatedMetadata",
        JSON.stringify({
          visibility: "PRIVATE",
          lifespan: "PERMANENT",
        }),
      );
      formData.append("uploadType", "DOCUMENT");
      formData.append("entityType", "SAFE_TRUCK_PARKING");
      const mediaInfosArray = [];
      for (let index = 0; index < params?.fileInfosArray?.length; index++) {
        const file = params?.fileInfosArray[index];
        const obj = {
          name: file.name,
          mediaType: file.mediaType,
          mediaCode: file.mediaCode,
        };
        mediaInfosArray.push(obj);
        formData.append(file.name, file.mediaObj);
      }
      formData.append("fileInfos", JSON.stringify(mediaInfosArray));
      formData.append("updateFiles", params?.deleteOldMedia);
      const json = {
        cust_id: params.cust_id,
        lic_plate_num: params.lic_plate_num,
        veh_type_cd: params.veh_type_cd,
        make: params.make,
        model: params.model,
        color: params.color,
        status: "A",
        source_sys: "mainGate",
        dotNumber: params.dotNumber,
        // picture: "jjguyfytfytd",
        vehicleStatus: "ACTIVE",
        trailerNumber: params.trailerNumber,
        crt_user: params.crt_user,
        last_upd_user: params.crt_user,
      };
      const vehicleBlob = new Blob([JSON.stringify(json)], {
        type: "application/json",
      });
      formData.append("vehicle", vehicleBlob);
      axios({
        method: "put",
        url: apiConfig.addVehicle + "/" + params.customerVehId,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          country: "USA",
          source: getDeviceName(),
          correlationId: generateUUID(),
          Authorization: `Bearer ${storePersist.get(
            localConstant.API_ACCESS_TOKEN,
          )}`,
        },
      })
        .then(function (response) {
          //handle success
          if (response.status >= 200 && response.status < 300) {
            dispatch({
              type: EDIT_VEHICLE_DETAILS_SUCCESS,
              payload: response.data,
            });
            callback(response);
          } else {
            dispatch({
              type: EDIT_VEHICLE_DETAILS_FAILURE,
              payload: response,
            });
            callback(response);
          }
        })
        .catch(function (response) {
          callback(response);
          dispatch({
            type: EDIT_VEHICLE_DETAILS_FAILURE,
            payload: response,
          });
        });
    } catch (error) {
      callback({});
      dispatch({
        type: EDIT_VEHICLE_DETAILS_FAILURE,
        payload: {},
      });
    }
  };

export const setSelectedVehicleDetails = (vehicle) => ({
  type: SET_SELECTED_VEHICLE_DETAILS,
  payload: vehicle,
});
